import "./index.css";

import { createApp } from "vue";
import App from "./App.vue";

// @ts-ignore
import VueMobileDetection from "vue-mobile-detection";
// @ts-ignore
import AOS from "aos";
// @ts-ignore
import { VLazyImagePlugin } from "v-lazy-image";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { initialize as icons } from "./icons";
import "aos/dist/aos.css";

import VueGtag from "vue-gtag-next";

import { router } from "./router";
import { store } from "./store";


icons(library);
const gtagConfig = {
  id: "G-9S14N2SNRS",
  includes: [{ id: "AW-967082918" }],
  accept_incoming: true,
};

const app = createApp(App);
app.config.globalProperties.window = window
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(VLazyImagePlugin);
app.use(store);
app.use(AOS.init({
  once: true
}));
app.use(router);
app.use(VueGtag, { property: gtagConfig });
app.use(VueMobileDetection);

app.mount("#app");
